import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getQuestionPapers, deleteQuestionPaper } from "../../api/PdfDetails";

const QuestionPapers = () => {
  const [papers, setPapers] = useState([]);

  // ✅ Fetch question papers
  const fetchPapers = async () => {
    try {
      const res = await getQuestionPapers();
      setPapers(res?.data || []);
    } catch (err) {
      console.error("Error fetching papers:", err);
    }
  };

  useEffect(() => {
    fetchPapers();
  }, []);

  // ✅ Delete functionality
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this paper?")) return;

    try {
      await deleteQuestionPaper(id);
      setPapers((prev) => prev.filter((paper) => paper.id !== id));
    } catch (err) {
      console.error("Error deleting paper:", err);
    }
  };

  // ✅ Download PDF in background
  const handleDownload = async (pdfUrl, pdfName) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = pdfName || "QuestionPaper.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href); // clean up
    } catch (err) {
      console.error("Error downloading PDF:", err);
      alert("Failed to download PDF");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 3,
          fontWeight: "bold",
          color: "primary.main",
          borderBottom: "3px solid",
          borderColor: "primary.main",
          display: "inline-block",
          pb: 1,
        }}
      >
        Question Papers
      </Typography>

      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "primary.main" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                SL No
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Class
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Subject
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Question Paper
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Date
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {papers.length > 0 ? (
              papers.map((paper, index) => (
                <TableRow key={paper.id} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{paper.class_name}</TableCell>
                  <TableCell>{paper.subject_name}</TableCell>
                  <TableCell>{paper.question_paper_name}</TableCell>
                  <TableCell>
                    {paper.downloaded_at
                      ? new Date(paper.downloaded_at).toLocaleDateString()
                      : "N/A"}
                  </TableCell>
                  <TableCell sx={{ display: "flex", gap: 1 }}>
                    {/* ✅ View PDF */}
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => window.open(paper.pdf_file, "_blank")}
                    >
                      View
                    </Button>

                    {/* ✅ Background Download */}
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() =>
                        handleDownload(
                          paper.pdf_file,
                          paper.question_paper_name + ".pdf"
                        )
                      }
                    >
                      Download
                    </Button>

                    {/* ✅ Delete PDF */}
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(paper.id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                  No Question Papers Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default QuestionPapers;
